import type { InputHTMLAttributes } from "react";
import { Icon } from "@/ui/icons/Icon";
import styles from "./ChatComposer.module.scss";

type InputAttributes = Pick<
  InputHTMLAttributes<HTMLInputElement>,
  | "type"
  | "inputMode"
  | "autoComplete"
  | "autoCapitalize"
  | "maxLength"
  | "enterKeyHint"
>;

interface ChatComposerProps extends InputAttributes {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  placeholder: string;
  // Read by screen readers instead of the placeholder.
  label: string;
  isLoading?: boolean;
}

// The text box of the conversation; each step sets the keyboard it needs.
export function ChatComposer({
  value,
  onChange,
  onSubmit,
  placeholder,
  label,
  isLoading = false,
  ...inputAttributes
}: ChatComposerProps) {
  const canSend = value.trim().length > 0 && !isLoading;

  return (
    <form
      className={styles.root}
      onSubmit={(event) => {
        event.preventDefault();
        if (canSend) {
          onSubmit();
        }
      }}
    >
      <input
        {...inputAttributes}
        className={styles.input}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        aria-label={label}
        disabled={isLoading}
        autoFocus
      />
      {canSend && (
        <button type="submit" className={styles.send} aria-label="Trimite">
          <Icon name="arrow-up-circle" className={styles.sendIcon} />
        </button>
      )}
    </form>
  );
}
